import React, { useEffect, useRef, useState } from 'react'
import '../Style/VerifyCode.css'
import ShowMessage from './ShowMessage'
import Loading_Screen from './Loading_Screen'
import ArrowLeftIcon from '../Logos/arrow-left-short.svg'
import PropagateLoader from "react-spinners/PropagateLoader";

function VerifyCode(props, PhoneNumber) {
    const [RequestCounting, SetRequestCounting] = useState(60)
    const [CanRequest, SetCanRequest] = useState(false)
    const [CanCountDown, SetCanCountDown] = useState(true)
    const [Loading, SetLoadingStatus] = useState(false)
    const [Error, SetError] = useState()

    const code1 = useRef()
    const code2 = useRef()
    const code3 = useRef()
    const code4 = useRef()
    const code5 = useRef()

    const RequestAgain = () => {
        SetRequestCounting(60)
        SetCanRequest(false)
        SetCanCountDown(true)
    }

    const CountDown = () => {
        if (CanCountDown) {
            setTimeout(() => {
                SetRequestCounting(RequestCounting - 1)
                if (RequestCounting <= 0) {
                    SetCanRequest(true)
                    SetCanCountDown(false)
                }
            }, 1000);
        }
    }
    useEffect(() => {
        CountDown()

        const code1ref = code1.current
        const code2ref = code2.current
        const code3ref = code3.current
        const code4ref = code4.current
        const code5ref = code5.current
        const Numbers = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"]
        code1ref.addEventListener("input", () => {
            if (code1ref.value.length > 0) {
                code2ref.focus()
            }
        })
        code2ref.addEventListener("keydown", (e) => {
            if (e.code === "Backspace") {
                if (code2ref.value.length > 0) {
                    return
                } else if (code2ref.value.length < 1) {
                    code1ref.focus()
                }
            }
        })
        code3ref.addEventListener("keydown", (e) => {
            if (e.code === "Backspace") {
                if (code3ref.value.length > 0) {
                    return
                } else if (code3ref.value.length < 1) {
                    code2ref.focus()
                }
            }
        })
        code4ref.addEventListener("keydown", (e) => {
            if (e.code === "Backspace") {
                if (code4ref.value.length > 0) {
                    return
                } else if (code4ref.value.length < 1) {
                    code3ref.focus()
                }
            }
        })
        code5ref.addEventListener("keydown", (e) => {
            if (e.code === "Backspace") {
                if (code5ref.value.length > 0) {
                    return
                } else if (code5ref.value.length < 1) {
                    code4ref.focus()
                }
            }
        })



        code2ref.addEventListener("input", () => {
            if (code2ref.value.length > 0) {
                code3ref.focus()
            }
        })
        code3ref.addEventListener("input", () => {
            if (code3ref.value.length > 0) {
                code4ref.focus()
            }
        })
        code4ref.addEventListener("input", () => {
            if (code4ref.value.length > 0) {
                code5ref.focus()
            }
        })
    })

    const StartCounting = () => {

    }

    
    const [Code, SetCode] = useState()
    const [Code1, SetCode1] = useState()
    const [Code2, SetCode2] = useState()
    const [Code3, SetCode3] = useState()
    const [Code4, SetCode4] = useState()
    const [Code5, SetCode5] = useState()
    const Handle_Code_Submit = (e) => {
        e.preventDefault()
        SetCode(Code1 + Code2 + Code3 + Code4 + Code5)
    }
    return (
        <>
            {/* <ShowMessage TypeOfError={"Success"} ErrorMessage={"test"}/> */}
            <form className='verify-code-contianer' onSubmit={(e) => {Handle_Code_Submit(e)}}>
                <div className='title'>درستی سنجی</div>
                <div className='description'>کد 5 رقمی ارسال شده به شماره موبایل خود را در قسمت زیر وارد کنید تا حساب کاربری شما ساخته شود</div>
                <div className='code-inputs'>
                    <input className='code1' name='code1' type='tel' ref={code1} maxLength={1} onChange={(e) => {SetCode1(e.target.value)}}/>
                    <input className='code2' name='code2' type='tel' ref={code2} maxLength={1} onChange={(e) => {SetCode2(e.target.value)}}/>
                    <input className='code3' name='code3' type='tel' ref={code3} maxLength={1} onChange={(e) => {SetCode3(e.target.value)}}/>
                    <input className='code4' name='code4' type='tel' ref={code4} maxLength={1} onChange={(e) => {SetCode4(e.target.value)}}/>
                    <input className='code5' name='code5' type='tel' ref={code5} maxLength={1} onChange={(e) => {SetCode5(e.target.value)}}/>
                </div>
                <div className='send-again'>
                    درخواست ارسال مجدد کد: <div className='timer'>{CanRequest ? <div className='request' onClick={() => { RequestAgain() }}>درخواست مجدد</div> : <div>{RequestCounting === 60 ? "1:00": RequestCounting}</div>}</div>
                </div>
                <button type='submit' className='submit-code-button'>ثبت</button>
                <div className='change-to-signup' onClick={() => {props.OnFormSwitch()}}><img src={ArrowLeftIcon} alt='arrow'/>بازگشت</div>
            </form>
        </>
    )
}

export default VerifyCode